/**
 * @deprecated Cette configuration est remplacée par src/services/config.ts
 * Utilisez import { config } from '../services/config' à la place
 */

import { config } from './config';

const BASE_URL_AUDIO = {
    url: config.api.audioBaseUrl,
}

export default BASE_URL_AUDIO;
